import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=6b951d39&"
import script from "./breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./breadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports